import {HashedPassword, NonEmptyString} from '@raison/types';
import crypto from 'crypto-js';
import {Decoder} from '@raison/prelude';

export const hashPassword = (password: NonEmptyString, salt: NonEmptyString): HashedPassword =>
    Decoder.run(
        HashedPassword,
        crypto
            .PBKDF2(password, salt, {keySize: 256 / 32, iterations: 10000, hasher: crypto.algo.SHA512})
            .toString(crypto.enc.Hex)
    ).orThrow();
